import React from 'react';
import Store, { persistor } from "./redux/Store";
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { AllPages } from './routes/routes';
import { MatxTheme } from 'app/components';
import { useRoutes, useLocation } from 'react-router-dom';
import { AuthProvider } from 'app/contexts/JWTAuthContext';
import { SettingsProvider } from 'app/contexts/SettingsContext';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { NavigateProvider, useCustomNavigate } from './utils/NavigateContext'; // Import NavigateContext

const App = () => {
    const all_pages = useRoutes(AllPages());

    return (
        <SettingsProvider>
            <MatxTheme>
                <AuthProvider>
                    <NavigateProvider>  {/* Wrap everything inside NavigateProvider */}
                        {/* <div className="route-wrapper"> */}
                        {all_pages}
                        {/* </div> */}
                    </NavigateProvider>
                </AuthProvider>
            </MatxTheme>
        </SettingsProvider>
    );
}

export default App;
